
import { Authtoken, Products, Info } from '../services/auth.js';

export async function ValidateLogin(tokenLocalStorage = "") {
  const uuid_module = "83073720-75dc-4a1c-ab99-3a8562b83d4c";
  var response = {
    token: null,
    auth: false,
    type: null,
    user: null
  };

  try {
    
    var authBearer = {
      acesso: false,
      roles: {},
      user: {}
      };
    var authUrl = false;
    var bearer = "";
    if (tokenLocalStorage) {
      authBearer = await Products(tokenLocalStorage);
    } else {
      var token = window.location.href.split("?token=")[1];
      var res = await Authtoken(token);
      bearer = res.access_token;
      authUrl = res.product_uuid === uuid_module;
    }
    if (authUrl) {
      response.type = "url";
      response.token = bearer;
      response.auth = true;
      response.user = await Info(bearer);
      const roles = await Products(bearer);
      response.roles = roles.roles;
    } else if (authBearer) {
      response.type = "bearer";
      response.auth = true;
      response.user = await Info(tokenLocalStorage);
      response.roles = authBearer.roles;
    } else {
      response.auth = false;
    }
    console.log('response ValidateLogin 01')
    console.log(response)
    if (response.roles === null || response.user === null) response.auth = false;
  } catch(error) { console.log('error', error)}
  return response;
}

